module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG01df46cc169a35ea5dca13ba19e98b66.01df46cc.png";